var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationProvider", {
    attrs: { rules: _vm.rules, mode: _vm.custom },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function({ classes }) {
            return [
              _c(
                "v-select",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "form-input",
                      class: [classes, { "non-searchable": !_vm.searchable }],
                      attrs: {
                        disabled: _vm.disabled,
                        searchable: _vm.searchable,
                        clearable: _vm.clearable
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "search",
                            fn: function(search) {
                              return _vm.searchable
                                ? [
                                    _vm._t(
                                      "input",
                                      function() {
                                        return [
                                          _c(
                                            "input",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  directives: [
                                                    {
                                                      name: "prefix",
                                                      rawName: "v-prefix",
                                                      value: _vm.prefix,
                                                      expression: "prefix"
                                                    },
                                                    {
                                                      name: "numbers-only",
                                                      rawName: "v-numbers-only",
                                                      value: _vm.numbersOnly,
                                                      expression: "numbersOnly"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control vs__search--custom m-b-0",
                                                  class: {
                                                    closed: !search.attributes[
                                                      "aria-expanded"
                                                    ]
                                                  }
                                                },
                                                "input",
                                                search.attributes,
                                                false
                                              ),
                                              search.events
                                            )
                                          )
                                        ]
                                      },
                                      null,
                                      {
                                        prefix: _vm.prefix,
                                        numbersOnly: _vm.numbersOnly,
                                        search
                                      }
                                    )
                                  ]
                                : undefined
                            }
                          },
                          {
                            key: "option",
                            fn: function(option) {
                              return [
                                _vm._t("option-data", null, { option: option })
                              ]
                            }
                          },
                          {
                            key: "selected-option",
                            fn: function(option) {
                              return [
                                _vm._t("selected-option-data", null, {
                                  option: option
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.dropdownValue,
                        callback: function($$v) {
                          _vm.dropdownValue = $$v
                        },
                        expression: "dropdownValue"
                      }
                    },
                    "v-select",
                    _vm.config,
                    false
                  ),
                  _vm.$listeners
                ),
                [
                  _vm._v(" "),
                  _vm._t("no-options", function() {
                    return [
                      _vm._v("\n      " + _vm._s(_vm.noOptionsText) + "\n    ")
                    ]
                  })
                ],
                2
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }